import { useRouter } from 'next/router';
import { useCallback } from 'react';
import storage from '../../util/storage';

/**
 * @description storage key to conditional render avatar modal
 */
export const AVATAR_MODAL = 'AVATAR_MODAL';

export const IMPORT_MODAL = 'IMPORT_MODAL';

/**
 * @description this hook serves to handle the success of project creation
 */
const useOnProjectCreationSuccess = ({
  setStorage = true,
}: {
  setStorage?: boolean;
} = {}) => {
  const router = useRouter();
  const onSuccess = useCallback(
    async ({
      projectId,
      actorId,
      variantId,
      variantVersion,
      targetModal,
    }: {
      projectId: string;
      actorId?: string;
      variantId?: string;
      variantVersion?: string;
      targetModal?: string;
    }) => {
      const modalKey = targetModal || AVATAR_MODAL;
      if (setStorage) {
        storage.setItem(modalKey, 'true');
      } else {
        storage.setItem(AVATAR_MODAL, 'false');
      }
      await router?.push({
        pathname: `/dashboard/studio/${projectId}`,
        ...(actorId && variantId
          ? {
              query: {
                actorId,
                variantId,
                variantVersion,
              },
            }
          : {}),
      });
    },
    [router]
  );
  return onSuccess;
};

export default useOnProjectCreationSuccess;
